import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography/Typography'

import {
  capitalize
} from '../../utils/helpers'

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.default, // toggle this to get two-tone background
  },
  sectionWrapper: {
    // TODO pass padding in as prop
    padding: "50px"
  },
  videoWrapper: {
    position: 'relative',
    paddingBottom: '56.25%', /* 16:9 */
    paddingTop: '25px',
    height: 0,
  },
  video: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  }
})

const VideoSection1 = ({
  classes,
  isFullScreen,
  title,
  subTitle,
  description,
  videoId,
}) => (
    <Grid
      item
      xs={isFullScreen ? 12 : 10}
      className={classes.root}
    >
      <Grid
        container
        spacing={0}
        className={classes.sectionWrapper}
        alignItems="center"
        direction="row-reverse"
      >

        {/* title */}
        <Grid item xs={12}>
          {title && typeof title === 'string' &&
            <Typography
              variant="display1"
              component="h2"
              align="center"
              gutterBottom
            >
              {title}
            </Typography>
          }
          {title && typeof title === 'function' &&
            <Typography
              variant="display1"
              component="h2"
              align="center"
              gutterBottom
            >
              {title()}
            </Typography>
          }
          {title && typeof title === 'object' &&
            <Typography
              variant="display1"
              component="h2"
              align="center"
              gutterBottom
            >
              {title}
            </Typography>
          }

          {subTitle && typeof subTitle === 'string' &&
            <Typography
              variant="headline"
              component="h3"
              align="center"
              gutterBottom
            >
              {subTitle}
            </Typography>
          }
          {subTitle && typeof subTitle === 'function' &&
            <Typography
              variant="headline"
              component="h3"
              align="center"
              gutterBottom
            >
              {subTitle()}
            </Typography>
          }
          {subTitle && typeof subTitle === 'object' &&
            <Typography
              variant="headline"
              component="h3"
              align="center"
              gutterBottom
            >
              {subTitle}
            </Typography>
          }          
        </Grid>

        {/* Video */}
        <Grid item xs={12}>
          <div className={classes.videoWrapper}>
            <iframe className={classes.video} width="560" height="315" src={`https://www.youtube.com/embed/${videoId}?rel=0`} frameBorder="0" allowFullScreen></iframe>
          </div>
        </Grid>

        {/* description */}
        <Grid item xs={12}>
          {description && typeof description === 'string' &&
            <Typography
              variant="caption"
              align="center"
            >
              {description}
            </Typography>
          }
          {description && typeof description === 'function' &&
            <Typography
              variant="caption"
              align="center"
            >
              {description()}
            </Typography>
          }
          {description && typeof description === 'object' &&
            <Typography
              variant="caption"
              align="center"
            >
              {description}
            </Typography>
          }          
        </Grid>

      </Grid>
    </Grid>
  )

VideoSection1.propTypes = {
  classes: PropTypes.object.isRequired,
  isFullScreen: PropTypes.bool.isRequired,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ]),
  subTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ]),
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ]), 
  videoId: PropTypes.string.isRequired,
};

export default withStyles(styles)(VideoSection1)


// WEBPACK FOOTER //
// ./src/components/sections/VideoSection1.js